/**
 * 날짜·시각 표시 — 주간 주요재고 확인(모바일)과 이력 탭(데스크톱)이 같이 쓴다 (v2.202.0).
 *
 * ⚠**요일은 `Date.UTC` 로 셀 것.** `new Date('2026-09-21T00:00:00+09:00').getUTCDay()` 는
 *   그 순간의 **UTC 날짜**(9/20 15시)를 보기 때문에 **하루 앞 요일**이 나온다 —
 *   실제로 월요일이 「(일)」로 찍혔다(2026-09-21 · 화면에서 잡았다).
 * 서버 쪽 같은 셈은 backend/src/lib/stock/check.ts 의 dayLabel·kstHm 이다.
 */

/** 'YYYY-MM-DD' → '9월 21일 (월)' */
export function dayLabel(d: string): string {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(d);
  if (!m) return d;
  const dow = ['일', '월', '화', '수', '목', '금', '토'][
    new Date(Date.UTC(Number(m[1]), Number(m[2]) - 1, Number(m[3]))).getUTCDay()
  ] ?? '';
  return `${Number(m[2])}월 ${Number(m[3])}일 (${dow})`;
}

/** ISO 시각 → KST 'HH:MM' (못 읽으면 '') */
export function timeLabel(iso: string | null | undefined): string {
  if (!iso) return '';
  const ms = new Date(iso).getTime();
  if (!Number.isFinite(ms)) return '';
  return new Date(ms + 9 * 3600_000).toISOString().slice(11, 16);
}

/** ISO 시각 → KST 'YYYY-MM-DD' (못 읽으면 '') */
export function kstDate(iso: string | null | undefined): string {
  if (!iso) return '';
  const ms = new Date(iso).getTime();
  if (!Number.isFinite(ms)) return '';
  return new Date(ms + 9 * 3600_000).toISOString().slice(0, 10);
}

/**
 * 오늘 날짜(KST) 'YYYY-MM-DD' (v2.228.1).
 * ⛔`new Date().toISOString().slice(0, 10)` 은 **UTC 날짜**라 한국 시간 00:00~08:59 에는 **어제**가 된다 —
 *   운영에서 아침 8시대에 쓴 구입지급결의서 작성일·매입 발주일이 하루 전으로 저장됐다(2026-10-06 확인).
 *   「오늘」 기본값은 반드시 이것으로. 그물: backend `npm run check:kst-today`.
 */
export function todayKst(now: Date = new Date()): string {
  return new Date(now.getTime() + 9 * 3600_000).toISOString().slice(0, 10);
}

/** ISO 시각 → '9월 28일 (월) 14:05' (못 읽으면 '') */
export function dateTimeLabel(iso: string | null | undefined): string {
  const d = kstDate(iso);
  return d ? `${dayLabel(d)} ${timeLabel(iso)}` : '';
}
